import { useContext } from 'react';

import WhereBuyContext from './whereBuy.context';

function useWhereBuy() {
  const context = useContext(WhereBuyContext);

  if (!context) {
    throw new Error('useVerification must be used within VerificationContext');
  }

  return context;
}

export default useWhereBuy;